import React from "react";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "antd";
import { NOTE_TYPE } from "constants/appConstant";
import { doAddNote, isSaving } from "stores/slices/note";

import AppButton from "components/button";

const NoteForm = props => {
  const {
    setOpenNoteForm,
    messageSelected,
    noteType = NOTE_TYPE.MESSAGE,
    conversationSelected,
    setIsRefresh,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const loading = useSelector(isSaving);

  const onFinish = async values => {
    const { note } = values;
    let request;
    if (noteType === NOTE_TYPE.MESSAGE) {
      request = {
        note: note,
        messageId: messageSelected && messageSelected.id,
        noteType: noteType,
      };
    } else {
      setIsRefresh(false);
      request = {
        note: note,
        customerId: conversationSelected && conversationSelected.customerId,
        noteType: noteType,
      };
    }

    const { payload } = await dispatch(doAddNote(request));
    if (payload && payload.status === 200) {
      setOpenNoteForm(false);
      if (setIsRefresh) {
        setIsRefresh(true);
      }
    }
  };

  return (
    <>
      <Form form={form} name="note-form" onFinish={onFinish}>
        <Form.Item name="note">
          <ReactQuill
            modules={editConfig()}
            className="noteEditor"
            placeholder="Add note..."
            onChange={value => {
              form.setFieldsValue({
                note: value,
              });
            }}
          />
        </Form.Item>
        <Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
            }}
          >
            <AppButton
              label={t("label.cancel")}
              color={"grey"}
              type="button"
              size={"minimum"}
              className={"cancelButton"}
              disabled={loading}
              onClick={() => {
                setOpenNoteForm(false);
              }}
            />
            <AppButton
              label={t("label.save")}
              htmlType="submit"
              color={"blue"}
              type="submit"
              size={"minimum"}
              disabled={loading}
            />
          </div>
        </Form.Item>
      </Form>
    </>
  );
};
const editConfig = () => {
  return {
    toolbar: [["bold", "italic"]],
  };
};

export default NoteForm;
